import { tipoConcesion } from "../../shared/Helpers/CalculosConcesiones";
import { FormatterNumber } from "../../../utils/formatter";
import "../../shared/styles/UnifiedTable.css";

const Tabla_concesiones = ({data, onClick}) => {

  return (
    <div className="unified-table-container">
      <table className="unified-table">
        <thead>
          <tr>
            <th className="text-center"><div>Acciones</div></th>
            <th className="text-start"><div>Cliente</div></th>
            <th className="text-center"><div>Nº Crédito</div></th>
            <th className="text-end"><div>Monto</div></th>
            <th className="text-center"><div>Cuotas</div></th>
            <th className="text-center"><div>Concesión</div></th>
            <th className="text-center"><div>Estado</div></th>
          </tr>
        </thead>
        <tbody>
          {data.map((concesion, index) => (
            <tr key={index}>
              <td className="text-center">
                <label className="btn btn-sm"
                  style={{
                    background: 'linear-gradient(135deg, #DC2626 0%, #B91C1C 100%)',
                    color: '#FFFFFF',
                    border: 'none',
                    borderRadius: '8px',
                    padding: '6px 12px',
                    fontSize: '0.85rem',
                    fontWeight: '600',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'
                  }}
                  title="Eliminar concesión"
                  onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                  onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                >
                  <i className="bi bi-trash me-1"></i>Eliminar
                  <button
                    className="d-none"
                    name="delete_concesion"
                    onClick={(event) => onClick(event, concesion)}
                  ></button>
                </label>
              </td>
              <td className="text-start">
                <span className="unified-table-link" style={{ cursor: 'default' }}>
                  {concesion.persona.apellido + " " + concesion.persona.nombre}
                </span>
              </td>
              <td className="text-center">
                <span className="unified-badge unified-badge-info">
                  #{concesion.credito.id}
                </span>
              </td>
              <td className="text-end">
                <span className="unified-money">
                  {FormatterNumber(concesion.credito.monto)}
                </span>
              </td>
              <td className="text-center">
                <span className="unified-badge unified-badge-secondary">
                  {concesion.credito.cuotas}
                </span>
              </td>
              <td className="text-center">
                <span className="unified-badge unified-badge-info">
                  {tipoConcesion(concesion.id_tipoconcesion)}
                </span>
              </td>
              <td className="text-center">
                {concesion.id_estado == 1 ? (
                  <span className="unified-badge unified-badge-info">Vigente</span>
                ) : concesion.id_estado == 2 ? (
                  <span className="unified-badge unified-badge-danger">Vencida</span>
                ) : concesion.id_estado == 3 ? (
                  <span className="unified-badge unified-badge-success">Finalizada</span>
                ) : concesion.id_estado == 4 ? (
                  <span className="unified-badge unified-badge-warning">Baja</span>
                ) : (
                  <span className="unified-badge unified-badge-secondary">-</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot></tfoot>
      </table>
    </div>
  );
}

export default Tabla_concesiones